import { render, staticRenderFns } from "./SearchCustomer.vue?vue&type=template&id=45c13618&scoped=true"
import script from "./SearchCustomer.vue?vue&type=script&lang=ts"
export * from "./SearchCustomer.vue?vue&type=script&lang=ts"
import style0 from "./SearchCustomer.vue?vue&type=style&index=0&id=45c13618&prod&lang=scss&scoped=true"
import style1 from "./SearchCustomer.vue?vue&type=style&index=1&id=45c13618&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c13618",
  null
  
)

export default component.exports